import {HttpRequest, HttpMethod} from "./http";

class AgentCommissionProvider extends HttpRequest {
    // Tiers (v1 — kept as thin shim over the default profile)
    TierList() {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/tiers`);
    }
    TierReplace(tiers) {
        return this.request(HttpMethod.Put, `/api/v3/agent-commission/tiers`, tiers);
    }

    // Profiles (v2)
    ProfileList() {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/profiles`);
    }
    ProfileGet(id) {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/profiles/${id}`);
    }
    ProfileCreate(payload) {
        return this.request(HttpMethod.Post, `/api/v3/agent-commission/profiles`, payload);
    }
    ProfileUpdate(id, payload) {
        return this.request(HttpMethod.Put, `/api/v3/agent-commission/profiles/${id}`, payload);
    }
    ProfileDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v3/agent-commission/profiles/${id}`);
    }

    // Agent <-> profile assignment (v2)
    AgentList() {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/agents`);
    }
    AgentSetProfile(userId, profileId) {
        return this.request(HttpMethod.Put, `/api/v3/agent-commission/agents/${userId}/profile`, { profile_id: profileId });
    }

    // Remittance import (v2)
    RemittanceImport(file, carrier) {
        const fd = new FormData();
        fd.append("file", file);
        if (carrier) fd.append("carrier", carrier);
        return this.request(HttpMethod.Post, `/api/v3/agent-commission/remittance/import`, fd);
    }
    RemittanceImportStatus() {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/remittance/import/status`);
    }
    RemittanceBatchList() {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/remittance/batches`);
    }
    RemittanceBatchRows(id, matched) {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/remittance/batches/${id}/rows`, matched ? { matched } : undefined);
    }
    RemittanceUnmatched() {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/remittance/unmatched`);
    }
    RemittanceRowMatch(rowId, boOrderId) {
        return this.request(HttpMethod.Post, `/api/v3/agent-commission/remittance/rows/${rowId}/match`, { bo_order_id: boOrderId });
    }
    RemittanceRowUnmatch(rowId) {
        return this.request(HttpMethod.Delete, `/api/v3/agent-commission/remittance/rows/${rowId}/match`);
    }

    // Rounds
    RoundList() {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/rounds`);
    }
    RoundPreview(code) {
        return this.request(HttpMethod.Post, `/api/v3/agent-commission/rounds/preview`, { code });
    }
    RoundCreate(payload) {
        return this.request(HttpMethod.Post, `/api/v3/agent-commission/rounds`, payload);
    }
    RoundGet(id) {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/rounds/${id}`);
    }
    RoundAgentOrders(id, userId) {
        return this.request(HttpMethod.Get, `/api/v3/agent-commission/rounds/${id}/agents/${userId}/orders`);
    }
    RoundDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v3/agent-commission/rounds/${id}`);
    }
}

export default AgentCommissionProvider;
